import React from "react";
import {Link} from "react-router";
import {styled} from "styled-components";

import LinkIcon from "@material-ui/icons/Link";

import StateIcon from "routes/llm_run/utils/render_test_status";

import {OrganisationId} from "common/types/organisation";
import {ScoredRun} from "../types";
import Chip from "@material-ui/core/Chip";

type Props = {
  organisationId: OrganisationId;
  runsToShow: ScoredRun[];
};

const LinkCell = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ShadedRow = styled.tr`
  &:nth-child(odd) td {
    background-color: #fcffdd;
  }
`;

export default function IndividualRuns({organisationId, runsToShow}: Props) {
  return (
    <table>
      <thead>
        <tr>
          <th>LLM Run Id</th>
          <th>Project Id</th>
          <th>Document Id</th>
          <th>Issue Id</th>
          <th>State</th>
          <th>Tests</th>
        </tr>
      </thead>
      <tbody>
        {runsToShow?.map(run => (
          <ShadedRow key={run.llm_run_id}>
            <td>
              <Link
                to={`/organisation/${organisationId}/llm_run/${run.llm_run_id}/detail`}
              >
                {run.llm_run_id}
              </Link>
            </td>
            <td>
              <LinkCell>
                {run.project_name}
                <Link
                  to={`/organisation/${organisationId}/project/${run.project_id}/document/list`}
                >
                  <LinkIcon />
                </Link>
              </LinkCell>
            </td>
            <td>
              <LinkCell>
                {run.document_name}
                <Link
                  to={`/organisation/${organisationId}/project/${run.project_id}/document/${run.document_id}/detail`}
                >
                  <LinkIcon />
                </Link>
              </LinkCell>
            </td>
            <td>
              <LinkCell>
                {run.issue_name}
                <Link
                  to={`/organisation/${organisationId}/issue/${run.issue_id}?open_issue_list=true&project=${run.project_id}&document=${run.document_id}`}
                >
                  <LinkIcon />
                </Link>
              </LinkCell>
            </td>
            <td>
              <StateIcon state={run.pass ? "pass" : "fail"} />
            </td>
            <td>
              {[...run.tests]
                .sort((a, b) => a.key.localeCompare(b.key))
                .map(test => (
                  <Chip
                    key={test.key}
                    label={formatKey(test.key)}
                    icon={<StateIcon state={test.state} />}
                  />
                ))}
            </td>
          </ShadedRow>
        ))}
      </tbody>
    </table>
  );
}

function formatKey(key: string) {
  return key
    .split("_")
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join(" ");
}
